<template>
  <div class="page flex-col">
    <div class="backBtn">
      <img
        @click="$router.back()"
        src="@/assets/icon/back.png"
      />
    </div>
    <img class="signSuccess" src="@/assets/images/signSuccess.png"/>
  </div>
</template>

<script>

import Vue from "vue";
import SignProcess from "../../components/signProcess";
import Fetch from "../../utils/fetch";
import { Dialog } from "vant";

import { Calendar, Progress } from "vant";
export default {
  name: "Jz",
  components: {
    SignProcess,
    Calendar,
    Vprogress: Progress,
  },
  data() {
    return {
      data: {},
      signData: {},
      running_days: 0,
      show_down: false,
      title: "",
      isSign: false,
      placeholderEleCount: 0,
      allDays: 0,
      reward_set_list: [],
      award_tips: "",
      award_num: "",
      signShow: false,
      year: null, //年份
      month: null, //月份
    };
  },
  created() {
    this.$parent.footer("user", false);
    let today = new Date();
    this.year = today.getFullYear();
    this.month = today.getMonth() + 1;
  },
  mounted() {
    this.init();
  },
  methods: {
    signBtn() {
      Fetch("/user/sign").then((r) => {
        this.signShow = true;
        this.running_days = r.data.days;
        this.isSign = true;
        this.award_tips = this.$t("sign.cash");
        this.award_num = r.data.reward_num;
        this.init();
      });
    },
    init() {
      Fetch("/user/sign_log").then((r) => {
        this.allDays = r.data.date_list;
      });

      // 累计奖励列表
      Fetch("/user/sign_reward").then((r) => {
        var reward_set = {};
        r.data.reward_list.forEach((item) => {
          reward_set[item.days] = {
            type: item.reward_type == 2 ? "djq" : "hb",
            value: item.reward_num,
            getstatus: item.can_draw,
            id: item.id,
          };
        });
        this.running_days = r.data.signin_days;
        this.isSign = r.data.isSign;
        this.reward_set_list = getRewardSetList(reward_set);
        this.signData = r.data.today_reward;
      });

      const year = today.getFullYear();
      const month = today.getMonth() + 1;

      // const days = getDaysFromCurrentMonth(year, month)
      this.title = `${year}-${month}`;
      // this.allDays = getDaysFromCurrentMonth(year, month)
      this.placeholderEleCount = getWeekdayOfMonth(year, month);
    },
  },
};
</script>

<style lang="less" scoped>
.page{
  width: 10rem;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
}
.backBtn {
  position: fixed;
  top: 1rem;
  left: 0.3rem;
  background-color: rgba(0, 0, 0, 0.5);
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    
  width: 0.27rem;
  height: 0.47rem;
  }
}
.signSuccess{
  width: 6rem;
}
</style>
